// extracted by mini-css-extract-plugin
export default {"HeaderTitle":"HeaderTitle_HeaderTitle__F4LCR","HeaderTitle__Text":"HeaderTitle_HeaderTitle__Text__NYp3M"};